import { render, staticRenderFns } from "./github-integration-accordion.vue?vue&type=template&id=1a925103&"
import script from "./github-integration-accordion.vue?vue&type=script&lang=ts&"
export * from "./github-integration-accordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports